// extracted by mini-css-extract-plugin
export var closeButton = "_mj-1";
export var closeX = "_mj-3";
export var container = "_mj-0";
export var image = "_mj-2";